import React, { useState } from 'react';
import styled from 'styled-components';
import { Guide, Loading } from 'tdesign-react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash';
import { useDebounceEffect } from 'ahooks';
import NoData from '@/components/NoData';
import { convertByte, hideShowMessage, shouldShowMessage } from '@/utils/common';
import ClusterSwitch from '@/components/Cluster/ClusterSwitch';
import { messageTypes } from '@/utils/constant';
import ListItem from './ListItem';

const convertByteRate = (num) => {
  const { value, unit } = convertByte(num);
  return {
    value,
    unit: `${unit}/S`,
  };
};

const steps = [
  {
    element: '.main-culster-list-item',
    title: '引导',
    body: '点击集群,查看详细信息',
    placement: 'bottom-right',
  },
];

function ListContainer({ loading, list }) {
  const [current, setCurrent] = useState(-1);

  useDebounceEffect(() => {
    if (shouldShowMessage(messageTypes.GUIDES_CLUSTER_LIST_GUIDE) && list.length > 0) {
      setCurrent(0);
    }
  }, [list]);

  const onFinish = () => {
    hideShowMessage(messageTypes.GUIDES_CLUSTER_LIST_GUIDE);
    setCurrent(-1);
  };

  return (
    <Root>
      <ClusterSwitch />
      <Loading loading={loading} />
      {isEmpty(list) ? (
        <NoData style={{ marginTop: 160 }} />
      ) : (
        list.map((item, index) => (
          <ListItem
            {...item}
            key={index}
            title={item.clusterName}
            displayName={item.displayName}
            node={item.clusterEnv}
            alive={item.clusterStatus === 'live'}
            chartPercent={Number(item.clusterHealth)}
            version={item.pulsarVersion}
            createTime={dayjs(item.createTime).format('YYYY-MM-DD hh:mm:ss')}
            isOpenFunctionService={item.isOpenFunctionService}
            isOpenKopService={item.isOpenKopService}
            tags={getTags(item)}
            items={getItems(item)}
            className={index === 0 ? 'main-culster-list-item' : ''}
          />
        ))
      )}
      <Guide
        current={current}
        steps={steps}
        onChange={setCurrent}
        onFinish={onFinish}
        onSkip={onFinish}
      />
    </Root>
  );
}

export default connect((state) => ({
  loading: state.cluster.loading,
  list: state.cluster.list,
}))(ListContainer);

const getTags = (item) => {
  const tags = [];
  if (item.deployEnv) {
    tags.push({
      title: item.deployEnv,
      background: 'rgba(102, 136, 255, 0.12)',
      color: '#6688FF',
    });
  }
  // if (item.deployMode) {
  //   tags.push({
  //     title: item.deployMode,
  //     background: 'rgba(102, 136, 255, 0.12)',
  //     color: '#6688FF',
  //   });
  // }
  if (item.deployVersion) {
    tags.push({
      title: item.deployVersion,
      background: 'rgba(16, 184, 128, 0.10)',
      color: '#10B880',
    });
  }
  if (item.clusterUsage) {
    tags.push({
      title: item.clusterUsage,
      background: 'rgba(244, 157, 11, 0.10)',
      color: '#F49D0B',
    });
  }
  return tags;
};

const getItems = (item) => {
  return [
    {
      title: 'Brokers',
      value: `${item.activeBrokersCount}/${item.brokersCount}`,
    },
    {
      title: 'Bookies',
      value: `${item.activeBookiesCount}/${item.bookiesCount}`,
    },
    {
      title: 'ZK',
      value: `${item.activeZkCount}/${item.zkCount}`,
    },
    // {
    //   title: '消息总条数',
    //   ...fmtNumber(item.totalMessages, '条'),
    // },
    {
      title: '消息总大小',
      ...convertByte(item.messageSize),
    },
    {
      title: '生产吞吐',
      ...convertByteRate(item.bytesIn),
    },
    {
      title: '消费吞吐',
      ...convertByteRate(item.bytesOut),
    },
    {
      title: 'Topic总数',
      value: item.topicCount,
    },
  ];
};

const Root = styled.div`
  flex: 1;
  min-width: 750px;
  position: relative;
  .t-loading {
    position: absolute;
    top: 200px;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 10;
  }
`;
